import { callApi } from "Apis";
import { BUSINESS_SUBCATEGORYURL } from "helpers/constant";
// business category list api...
export async function getBusinessSubCategoryListApi(data) {
  try {
    const response = await callApi({
      url: BUSINESS_SUBCATEGORYURL.LIST,
      body: data,
      method: "POST",
    });
    return response;
  } catch (error) {
    throw error;
  }
}
// business category add api...
export async function addBusinessSubCategoryApi(data) {
  try {
    const response = await callApi({
      url: BUSINESS_SUBCATEGORYURL.ADD,
      body: data,
      method: "POST",
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category edit api...
export async function getBusinessSubCategoryDataByIdApi(id) {
  try {
    const response = await callApi({ url: BUSINESS_SUBCATEGORYURL.GET(id), method: "GET" });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category update api...
export async function updateBusinessSubCategoryDataApi(data) {
  try {
    const response = await callApi({
      url: BUSINESS_SUBCATEGORYURL.UPDATE,
      body: data,
      method: "PUT",
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// business category delete api...
export async function deleteBusinessSubCategoryDataApi(id) {
  try {
    const response = await callApi({ url: BUSINESS_SUBCATEGORYURL.DELETE(id), method: "DELETE" });
    return response;
  } catch (error) {
    throw error;
  }
}
